export const realRainBrand = Object.freeze({
  ink: "#202624",
  inkMuted: "#5F6964",
  canvas: "#FFFFFF",
  surface: "#FFFFFF",
  line: "#DDE3DF",
  lineStrong: "#B5C0B9",
  realrain: Object.freeze({ base: "#708F88", strong: "#426359", soft: "#E1EAE7" }),
  studio: Object.freeze({ base: "#897991", strong: "#76667E", soft: "#F0EAF4" }),
  hub: Object.freeze({ base: "#7F9098", strong: "#607078", soft: "#E7ECEF" }),
  fair: Object.freeze({ base: "#B56562", strong: "#9E514F", soft: "#FCE9E7" }),
});

export const realRainProducts = Object.freeze({
  account: Object.freeze({ id: "account", name: "RealRain Account", shortName: "Account", tone: "realrain" }),
  studio: Object.freeze({ id: "studio", name: "RainStudio", shortName: "Studio", tone: "studio" }),
  hub: Object.freeze({ id: "hub", name: "RainHub", shortName: "Hub", tone: "hub" }),
  fair: Object.freeze({ id: "fair", name: "RainFair", shortName: "Fair", tone: "fair" }),
  ontology: Object.freeze({ id: "ontology", name: "RainOntology", shortName: "Ontology", tone: "realrain" }),
});

export function productManifest(product) {
  return realRainProducts[product] ?? realRainProducts.account;
}
